import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { Separator } from "@/components/ui/separator";
import { useDispatch } from "react-redux";
import { logoutAsync } from "@/redux/authSlice";
import { AppDispatch, RootState } from "@/redux/store";
import { useNavigate } from "react-router-dom";
import { useToast } from "../use-toast";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { setCode, setCounter } from "@/redux/counterSlice";
import { Badge } from "../badge";
import { useGetStaffByIdQuery } from "@/services/staffsApi";
import profileimg from "@/assets/profile-image.svg";
import { breadcrumbs, pageTitles } from "@/lib/constants/header";
import { useGetCounterByIdQuery } from "@/services/counterApi";
const { VITE_VIEW_S3_URL } = import.meta.env;

const Breadcrumb = ({
  currentPath,
  targetPath,
  title,
  pageSetting,
}: {
  currentPath: string;
  targetPath: string;
  title: string;
  pageSetting?: string;
}) => {
  if (!isActiveLink(currentPath, targetPath)) return null;
  return (
    <div className="pl-7  text-sm">
      <span className="text-gray-400 pr-1 font-semibold text-sm">
        {pageSetting}
      </span>{" "}
      <span className="text-gray-400 font-semibold ">/</span>
      <span className="pl-1 text-primary font-semibold text-sm">{title}</span>
    </div>
  );
};

const PageTitle = ({
  currentPath,
  targetPath,
  title,
}: {
  currentPath: string;
  targetPath: string;
  title: string;
}) => {
  if (!isActiveLink(currentPath, targetPath)) return null;
  return <p className="text-lg">{title}</p>;
};

const isActiveLink = (currentPath: string, targetPath: string) => {
  if (currentPath == targetPath) return true; // Exact match
  if (targetPath.endsWith("/") && currentPath.startsWith(targetPath)) {
    return true; // Prefix match for paths ending with "/"
  } else if (currentPath.startsWith(targetPath) && !targetPath.includes("facility") && !targetPath.includes("members")) {
    return true;
  }
  return false;
};

export const Header = () => {
  const location = useLocation();
  const counter_number =
    (localStorage.getItem("counter_number") as string) == ""
      ? null
      : Number(localStorage.getItem("counter_number") as string);

  const { toast } = useToast();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch<AppDispatch>();

  const handleLogout = () => {
    dispatch(setCode(null));
    dispatch(setCounter(null));
    dispatch(logoutAsync());
    toast({
      variant: "success",
      title: "Logout",
      description: "You are Successfully Logged Out",
    });
    navigate("/admin/members", { replace: true });
  };

  const { data: profileInfo } = useGetStaffByIdQuery(
    userInfo?.user?.id as number,
    {
      skip: userInfo?.user?.id == null,
    }
  );

  const { data: counterData } = useGetCounterByIdQuery(counter_number as number, {
    skip: counter_number == null || counter_number == 0,
  })

  console.log(`${VITE_VIEW_S3_URL}/${profileInfo?.profile_img}`);

  return (
    <header className="font-poppins sticky top-0 z-20  flex h-32 slg:h-16 items-center justify-between border-b bg-white px-1 shadow-sm">
      <div className="flex w-full justify-between items-start gap-4 flex-col slg:flex-row slg:items-center">
        <div className="w-full slg:!w-[calc(100%-280px)] flex flex-row h-full justify-between items-center ">
          <div className="w-full flex flex-col my-0">
            <h1 className="text-2xl  font-bold  pl-7 ">
              {pageTitles.map(({ targetPath, title }, index) => (
                <PageTitle
                  key={index}
                  currentPath={location.pathname}
                  targetPath={targetPath}
                  title={title}
                />
              ))}
            </h1>
            <div className="flex ">
              {breadcrumbs.map(({ targetPath, title, pageSetting }, index) => (
                <Breadcrumb
                  key={index}
                  currentPath={location.pathname}
                  targetPath={targetPath}
                  title={title}
                  pageSetting={pageSetting}
                />
              ))}
            </div>
          </div>

          {counter_number && (
            <Badge className=" text-white  mx-2">
              <span className="text-nowrap capitalize">
                Opened Counter: {counterData?.name}
              </span>
            </Badge>
          )}
        </div>

        <div className="w-fit slg:max-w-[340px] flex flex-row justify-end slg:justify-center items-center gap-3 px-2 slg:px-0">
          <Separator orientation="vertical" className="h-10" />
          <div className="flex flex-row justify-center items-center gap-4">
            <div className="w-8 h-8 border-[1px] border-gray-400 rounded-full justify-center flex items-center">
              <i className="fa-regular fa-envelope"></i>
            </div>
            <div className="w-8 h-8 border-[1px] border-gray-400 rounded-full justify-center flex items-center">
              <i className="fa-regular fa-bell"></i>
            </div>
          </div>
          <Separator orientation="vertical" className="h-10" />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <div className="justify-center cursor-pointer items-center flex gap-3">
                <div className="relative size-8 rounded-full">
                  <img
                    id="avatar"
                    src={
                      profileInfo?.profile_img &&
                        profileInfo?.profile_img !== ""
                        ? `${VITE_VIEW_S3_URL}/${profileInfo?.profile_img}`
                        : profileimg
                    }
                    loading="lazy"
                    alt={"/profileimg"}
                    className="size-8 rounded-full object-cover  relative"
                  />
                </div>
                <h1 className="text-base capitalize">
                  {userInfo?.user?.first_name}
                </h1>
                <Button
                  variant="ghost"
                  size="icon"
                  className="rounded-full w-2 px-2.5"
                >
                  <i className="fa-solid fa-caret-down "></i>
                </Button>
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              {/* <DropdownMenuItem>Profile</DropdownMenuItem>
              <DropdownMenuItem>Settings</DropdownMenuItem>
              <DropdownMenuItem>Support</DropdownMenuItem>
              <DropdownMenuSeparator /> */}
              <DropdownMenuItem onClick={handleLogout}>Logout</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
};